export const APP_HIDE_LOADING = 'APP_HIDE_LOADING'
export const APP_SHOW_LOADING = 'APP_SHOW_LOADING'

export default {
  APP_HIDE_LOADING,
  APP_SHOW_LOADING
}
